export default __webpack_public_path__ + "static/media/timeline-1.25f87512.jpg";